import { AbstractParser } from "../../parser";
import { SalesHistoryCompany } from "src/app/ui/models/domains/pbm/sales-history/sales-history-company";
import { SalesHistorySummary } from "src/app/ui/models/domains/pbm/sales-history/sales-history-summary";
import { CompanySalesHistoryItem } from "src/app/ui/models/domains/pbm/sales-history/company-sales-history-item";
import { PagingInfo } from "src/app/ui/models/domains/paginator/paging-info.model";

export class FindSalesHistoryByFiscalNumberParser extends AbstractParser<SalesHistoryCompany> {
  parse(payload: any): SalesHistoryCompany {
    const salesHistoryCompany = new SalesHistoryCompany();
    salesHistoryCompany.setPagingInfo(this.parsePagingInfo(payload.PageableResult));
    salesHistoryCompany.setFiscalNumber(payload.Company.FiscalNumber);
    salesHistoryCompany.setCorporateName(payload.Company.CorporateName);
    salesHistoryCompany.setEmployeeCount(payload.Company.CompanyInfo.EmployeeCount);
    salesHistoryCompany.setSalesHistorySummary(this.parseSalesHistorySummary(payload.Summary));
    salesHistoryCompany.setcompanySalesHistoryItemList(this.parseCompanySalesHistoryItemList(payload.PageableResult.Items));
    return salesHistoryCompany;
  }

  private parsePagingInfo(payload: any): PagingInfo {
    const pagingInfo = new PagingInfo();
    pagingInfo.setStart(payload.Start);
    pagingInfo.setEnd(payload.End);
    return pagingInfo;
  }

  private parseSalesHistorySummary(payload: any): SalesHistorySummary {
    const salesHistorySummary = new SalesHistorySummary();
    salesHistorySummary.setProductSoldCount(payload.ProductSoldCount);
    salesHistorySummary.setSalesValueableCount(payload.SalesValueableCount);
    salesHistorySummary.setSalesSubsidyValueCount(payload.SalesSubsidyValueCount);
    salesHistorySummary.setPaymentrollValueCount(payload.PaymentrollValueCount);
    return salesHistorySummary;
  }

  private parseCompanySalesHistoryItemList(payload: any): CompanySalesHistoryItem[] {
    const companySalesHistoryItems: CompanySalesHistoryItem[] = payload.map((item) => {
      const companySalesHistoryItem = new CompanySalesHistoryItem();
      companySalesHistoryItem.setEan(item.Ean);
      companySalesHistoryItem.setProductName(item.ProductName);
      companySalesHistoryItem.setSoldItemCount(item.SoldItemCount);
      companySalesHistoryItem.setStateName(item.State.Name);
      companySalesHistoryItem.setCity(item.State.City);
      companySalesHistoryItem.setDistrict(item.State.District);
      companySalesHistoryItem.setNetworkName(item.Network.Name);
      companySalesHistoryItem.setNetworkFiscalNumber(item.Network.FiscalNumber);
      companySalesHistoryItem.setSoldValueCount(item.SoldValueCount);
      return companySalesHistoryItem;
    });
    return companySalesHistoryItems;
  }
}
